import { Checkbox as RsCheckbox, RadioGroup as RsCheckboxGroup } from 'rsuite'
import { FormikCheckboxInputs } from './interfaces'

function CheckboxGroup<V>(
  props: Readonly<FormikCheckboxInputs<V>>
): React.ReactElement {
  const { formik, name, inputProps } = props
  const selectedValue: string =
    (formik?.values as Record<string, string>)[name] ?? ''

  const selectOptions = inputProps?.selectOptions ?? []

  const handleCheckboxChange = (value: string) => {
    const newValue = selectedValue === value ? '' : value
    formik?.setFieldValue(name, newValue)
  }

  return (
    <RsCheckboxGroup inline>
      {selectOptions.map((option: any) => (
        <RsCheckbox
          key={option.value}
          value={option.value}
          checked={option.value === selectedValue}
          onChange={() => handleCheckboxChange(option.value)}
          disabled={inputProps?.isDisabled}
          data-testid={`${name}-${option.value}`}
          className={selectedValue === option.value ? 'active-checkbox' : ''}
        >
          {option.label}
        </RsCheckbox>
      ))}
    </RsCheckboxGroup>
  )
}

export default CheckboxGroup
